import { DataDisplayEvent, DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutCustomerQuickInfoMulticompany } from "./autogen/AutogenLayoutCustomerQuickInfoMulticompany";
import { StringUtil } from "@mcleod/core";

export class CustomerQuickInfoMulticompany extends AutogenLayoutCustomerQuickInfoMulticompany {
    /** This is an event handler for the afterExecution event of sourceCustomerLookupMulticompany. */
    sourceCustomerLookupMulticompanyAfterExecution(event: DataSourceExecutionEvent) {
        this.textboxPartnerValue.visible = this.mainDataSource?.activeRow?.getBoolean("partner_value_visible", false);
        this.textboxScac.visible = this.mainDataSource?.activeRow?.getBoolean("edi_customer_scac_visible", false);
        this.textboxEdiCustomerCarrier.visible = this.mainDataSource?.activeRow?.getBoolean("edi_customer_carrier_visible", false);
        const bridgeId = this.mainDataSource?.activeRow?.getString("bridge_id", null);
        this.labelBridgeIdDescription.visible = !StringUtil.isEmptyString(bridgeId);
        this.textboxBridgeCustomer.visible = !StringUtil.isEmptyString(bridgeId);
    }
}
